<template>
  <basic-container id="carcouponshop20220323">
    <!--    <el-form :inline="true" ref="form" :model="query">-->
    <!--      <el-row>-->
    <!--        <el-col span="6" style="padding-left: 10px;">-->
    <!--          <el-form-item label="车场名称:">-->
    <!--            <el-select-->
    <!--              v-model="query.parkingLotId"-->
    <!--              style="width: 100%; "-->
    <!--              placeholder="请选择车场"-->
    <!--              size="small"-->
    <!--            >-->
    <!--              <el-option-->
    <!--                v-for="item in parkingLotList"-->
    <!--                :key="item.id"-->
    <!--                :label="item.title"-->
    <!--                :value="item.id"-->
    <!--              >-->
    <!--              </el-option>-->
    <!--            </el-select>-->
    <!--          </el-form-item>-->
    <!--        </el-col>-->

    <!--        <el-col span="18" align="right">-->
    <!--          <el-form-item>-->
    <!--            <el-button type="primary" size="small" icon="el-icon-search" @click="search">搜 索</el-button>-->
    <!--             <el-button type="default" size="small" icon="el-icon-delete" @click="searchReset">清 空</el-button>-->
    <!--          </el-form-item>-->
    <!--        </el-col>-->
    <!--      </el-row>-->
    <!--    </el-form>-->
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="parkingLotIdSearch" slot-scope="scope">
        <selectSearch  v-model="query.parkingLotId" :dicData="parkingLotList"></selectSearch>
        <!-- <el-select
          v-model="query.parkingLotId"
          placeholder="车场名称:"
          style="width: 100%"
          @change="(value) => parkingLotIdChange(value)"
        >
          <el-option
            v-for="item in parkingLotList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </template>
      <template slot-scope="scope" slot="shopBalance">
        <div class="money">
          <span>{{ tool.money_format_allowvoid(scope.row.shopBalance) }}</span>
        </div>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="couponShopDialogOpen"
          v-if="permission.carcouponshop_add"
          >新 增
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.carcouponshop_edit"
          @click="couponShopEditDialogOpen(scope.row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          v-if="permission.carcouponshop_delete"
          @click="rowDel(scope.row)"
          >删除</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-money"
          @click="openShopRechargeDialog(scope.row)"
          >充值</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-money"
          @click="openShopRechargeDetail(scope.row)"
          >充值记录</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-money"
          @click="openSendCouponsDialog(scope.row)"
          >发券详情</el-button
        >
      </template>

      <template slot="couponNum" slot-scope="scope">
        <span> {{ scope.row.couponNum }}种</span>
      </template>
    </avue-crud>
    <el-dialog
      title="新增"
      :visible.sync="couponShopAddShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="couponShopDialogClose"
      width="50%"
    >
      <div class="el-dialog-div">
        <el-form ref="addForm" :rules="rules" :model="addForm" label-width="120px">
          <el-row>
            <el-col span="11">
              <el-form-item label="车场名称:" prop="parkingLotId">
                <selectSearch  v-model="addForm.parkingLotId" :dicData="parkingLotList"></selectSearch>
                <!-- <el-select
                  v-model="addForm.parkingLotId"
                  placeholder="请选择车场"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in parkingLotList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="商家名称:" prop="shopName">
                <el-input v-model="addForm.shopName" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="责任人:" prop="shopResponsiblePerson">
                <el-input
                  v-model="addForm.shopResponsiblePerson"
                  maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="手机号码:" prop="shopPersonPhone">
                <el-input
                  v-model="addForm.shopPersonPhone"
                  maxlength="11"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="appId:" prop="appId">
                <el-input v-model="addForm.appId" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="KEY:" prop="appKey">
                <el-input v-model="addForm.appKey" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item
                label="授信额度:"
                prop="shopCreditAmount"
                :rules="[{ required: true, message: '请输入授信额度', trigger: 'blur' }]"
              >
                <el-input
                  v-model="addForm.shopCreditAmount"
                  type="number"
                  maxlength="9"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item
                label="商家扣费方式:"
                prop="subtractType"
                :rules="[{ required: true, message: '请选择扣费方式', trigger: 'change' }]"
              >
                <el-select
                  v-model="addForm.subtractType"
                  style="width: 100%"
                  placeholder="请选择商家扣费方式"
                  filterable
                >
                  <el-option
                    v-for="item in subtractTypeList"
                    :key="item.subtractTypeKey"
                    :label="item.subtractTypeLabel"
                    :value="item.subtractTypeKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;告警设置</h3>
            <el-col span="7">
              <el-form-item
                label="余额少于:"
                prop="lowerBalance"
                :rules="[{ required: true, message: '请输入最低余额', trigger: 'blur' }]"
              >
                <el-input v-model="addForm.lowerBalance" type="number"> </el-input>
              </el-form-item>
            </el-col>
            <el-col span="17">
              <div style="display: flex; align-items: center; height: 30px">
                元，
                <el-form-item
                  prop="notifyType"
                  label="通知方式:"
                  :rules="[{ required: true, message: '请选择通知方式', trigger: 'change' }]"
                  label-width="85px"
                  style="margin-bottom: 0"
                >
                  <el-select
                    v-model="addForm.notifyType"
                    clearable="true"
                    style="width: 150px; height: 30px"
                  >
                    <el-option
                      v-for="item in shopNotifyMethodList"
                      :key="item.id"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label=""
                  prop="notifySplit"
                  :rules="[{ required: true, message: '请输入通知间隔', trigger: 'blur' }]"
                  label-width="25px"
                  style="margin-bottom: 0"
                >
                  <el-input
                    v-model="addForm.notifySplit"
                    type="number"
                    maxlength="2"
                    style="width: 100px"
                  ></el-input
                  >&nbsp;天通知1次
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;关联用户</h3>
            <el-col span="22">
              <el-form-item label="添加用户:" prop="shopUser">
                <el-select
                  v-model="addForm.shopUser"
                  placeholder="请选择用户"
                  size="small"
                  multiple
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in shopUseList"
                    :key="item.userKey"
                    :label="item.userLabel"
                    :value="item.userKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="float: right">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="couponShopAddSubmit"
                  size="small"
                  >保存</el-button
                >
                <el-button icon="el-icon-delete" @click="couponShopDialogClose" size="small"
                  >取消</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="couponShopEditShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="couponShopEditDialogClose"
      width="50%"
    >
      <div class="el-dialog-div">
        <el-form ref="editForm" :rules="editRules" :model="editForm" label-width="120px">
          <el-row>
            <el-col span="11">
              <el-form-item label="车场名称:" prop="parkingLotName">
                <el-input v-model="editForm.parkingLotName" disabled></el-input>
                <el-input v-model="editForm.parkingLotName" v-show="false"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="商家名称:" prop="shopName">
                <el-input v-model="editForm.shopName" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="责任人:" prop="shopResponsiblePerson">
                <el-input
                  v-model="editForm.shopResponsiblePerson"
                  maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="手机号码:" prop="shopPersonPhone">
                <el-input
                  v-model="editForm.shopPersonPhone"
                  maxlength="11"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item label="appId:" prop="appId">
                <el-input v-model="editForm.appId" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item label="KEY:" prop="appKey">
                <el-input v-model="editForm.appKey" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="11">
              <el-form-item
                label="授信额度:"
                prop="shopCreditAmount"
                :rules="[{ required: true, message: '请输入授信额度', trigger: 'blur' }]"
              >
                <el-input
                  v-model="editForm.shopCreditAmount"
                  type="number"
                  maxlength="9"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col span="11">
              <el-form-item
                label="商家扣费方式:"
                prop="subtractType"
                :rules="[{ required: true, message: '请选择扣费方式', trigger: 'change' }]"
              >
                <el-select
                  v-model="editForm.subtractType"
                  style="width: 100%"
                  placeholder="请选择商家扣费方式"
                  filterable
                >
                  <el-option
                    v-for="item in subtractTypeList"
                    :key="item.subtractTypeKey"
                    :label="item.subtractTypeLabel"
                    :value="item.subtractTypeKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;告警设置</h3>
            <el-col span="7">
              <el-form-item
                label="余额少于:"
                prop="lowerBalance"
                :rules="[{ required: true, message: '请输入最低余额', trigger: 'blur' }]"
              >
                <el-input v-model="editForm.lowerBalance" type="number"> </el-input>
              </el-form-item>
            </el-col>
            <el-col span="17">
              <div style="display: flex; align-items: center; height: 30px">
                元，
                <el-form-item
                  prop="notifyType"
                  label="通知方式:"
                  :rules="[{ required: true, message: '请选择通知方式', trigger: 'change' }]"
                  label-width="85px"
                  style="margin-bottom: 0"
                >
                  <el-select
                    v-model="editForm.notifyType"
                    clearable="true"
                    style="width: 150px; height: 30px"
                  >
                    <el-option
                      v-for="item in shopNotifyMethodList"
                      :key="item.id"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label=""
                  prop="notifySplit"
                  :rules="[{ required: true, message: '请输入通知间隔', trigger: 'blur' }]"
                  label-width="25px"
                  style="margin-bottom: 0"
                >
                  <el-input
                    v-model="editForm.notifySplit"
                    type="number"
                    maxlength="2"
                    style="width: 100px"
                  ></el-input
                  >&nbsp;天通知1次
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;关联用户</h3>
            <el-col span="22">
              <el-form-item label="添加用户:" prop="shopUser">
                <el-select
                  v-model="editForm.shopUser"
                  placeholder="请选择用户"
                  size="small"
                  multiple
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in shopUseList"
                    :key="item.userKey"
                    :label="item.userLabel"
                    :value="item.userKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="float: right">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="couponShopEditSubmit"
                  size="small"
                  >保存</el-button
                >
                <el-button icon="el-icon-delete" @click="couponShopEditDialogClose" size="small"
                  >取消</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="充值"
      :visible.sync="shopRechargeDialogFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="quitShopRechargeDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="shopRechargeFormRef"
          v-model="shopRechargeForm"
          :option="shopRechargeOption"
          @submit="shopRechargeSubmit"
        >
          <!-- 充值金额 -->
          <template slot="rechargeAmount">
            <div>
              <moneyInput2
                v-model="shopRechargeForm.rechargeAmount"
                placeholder="请输入充值金额"
                style="width: 100%"
                template="append"
                @input="rechargeAmountInputChange"
              >
              </moneyInput2>
            </div>
          </template>
          <!-- 优惠折扣 -->
          <template slot="discountType">
            <el-select
              v-model="shopRechargeForm.discountType"
              clearable="true"
              :disabled="rechargeAmountFlag"
              @change="changeDiscountType"
            >
              <el-option
                v-for="item in discountTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </template>

          <template slot-scope="scope" slot="menuForm" style="text-align: right">
            <el-button icon="el-icon-delete" @click="quitShopRechargeDialog" size="small"
              >取消</el-button
            >
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <sendCoupons @onLoad="onLoad" ref="sendCoupons"></sendCoupons>
    <ShopRechargeDetail
      v-if="shopRechargeDetailVisible"
      :visible.sync="shopRechargeDetailVisible"
      :shopId="shopId"
    ></ShopRechargeDetail>
  </basic-container>
</template>

<script>
import { getDictionary } from '@/api/common';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  userList,
  syncShop,
  getShopRechargeView,
  shopRechargeSave,
  shopAmountCalculate,
} from '@/api/v4ward/park/couponv2/shop/carcouponshop';
import { mapGetters } from 'vuex';
import sendCoupons from './send-coupons.vue';
import moneyInput2 from '@/components/money-input2/index.vue';
import shopRechargeOption from './shop-recharge-option';
import ShopRechargeDetail from './shop-recharge-detail';
export default {
  components: { sendCoupons, ShopRechargeDetail, moneyInput2 },
  data() {
    // 手机号码验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      }
      if (!Number.isInteger(+value)) {
        callback(new Error('请输入数字值'));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error('手机号码格式不正确'));
        }
      }
    };

    // 0-100数值校验
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('百分比不能为空'));
      }
      if (!Number.isInteger(+value)) {
        callback(new Error('请输入数字值'));
      } else {
        if (value < 0 || value > 100) {
          callback(new Error('请输入0-100数值'));
        } else {
          callback();
        }
      }
    };
    return {
      rechargeAmountFlag: false,
      subtractTypeList: [
        {
          subtractTypeKey: '0',
          subtractTypeLabel: '发券时扣除理论金额',
        },
        {
          subtractTypeKey: '1',
          subtractTypeLabel: '用券时扣除实际金额',
        },
      ],
      //【充值】弹框相关参数
      shopRechargeDialogFlag: false,
      shopRechargeForm: {
        rechargeAmount: '',
      },
      discountTypeList: [{ dict_key: '', dict_value: '' }],
      shopRechargeOption: shopRechargeOption,
      shopRechargeDetailVisible: false,
      shopId: '',

      query: {
        parkingLotId: '',
      },
      parkingLotList: [],
      shopUseList: [],
      shopNotifyMethodList: [],
      //新增
      couponShopAddShow: false,
      addForm: {
        notifySplit: '',
        notifyType: '',
        lowerBalance: '',
        parkingLotId: '',
        shopName: '',
        appId: '',
        noBalanceGetCoupon: '1',
        appKey: '',
        shopCreditAmount: '',
        shopResponsiblePerson: '',
        shopPersonPhone: '',
        shopLimitAmount: '',
        shopLimitNotify: '',
        shopNotifyMethod: '',
        shopUser: '',
        subtractType: '',
      },
      rules: {
        parkingLotId: [{ required: true, message: '请选择车场', trigger: 'blur' }],
        shopName: [
          { required: true, message: '请输入商家名称', trigger: 'blur' },
          { max: 50, message: '优惠券名称最大长度为50字符', trigger: 'blur' },
        ],
        shopResponsiblePerson: [
          { required: true, message: '请输入责任人', trigger: 'blur' },
          { min: 2, max: 12, message: '责任人名称长度在2-12位', trigger: 'blur' },
        ],
        shopPersonPhone: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        shopLimitAmount: [
          { required: true, message: '请输入限额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^(?:[1-9]\d*|0)$/.test(value) == false) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        shopLimitNotify: [{ required: true, validator: checkNum, trigger: 'blur' }],
        shopUser: [{ message: '请选择用户', required: true, trigger: 'blur' }],
        notifySplit: [
          {
            validator: (rule, value, callback) => {
              if (value > 365 || value < 1) {
                callback(new Error('请输入1~365之间的正整数'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
      //编辑
      couponShopEditShow: false,
      editForm: {
        notifySplit: '',
        notifyType: '',
        lowerBalance: '',
        parkingLotName: '',
        parkingLotId: '',
        shopName: '',
        appId: '',
        appKey: '',
        shopCreditAmount: '',
        noBalanceGetCoupon: '',
        shopResponsiblePerson: '',
        shopPersonPhone: '',
        shopLimitAmount: '',
        shopLimitNotify: '',
        shopNotifyMethod: '',
        shopUser: '',
        subtractType: '',
      },
      editRules: {
        shopName: [
          { required: true, message: '请输入商家名称', trigger: 'blur' },
          { max: 50, message: '优惠券名称最大长度为50字符', trigger: 'blur' },
        ],
        shopResponsiblePerson: [
          { required: true, message: '请输入责任人', trigger: 'blur' },
          { min: 2, max: 12, message: '责任人名称长度在2-12位', trigger: 'blur' },
        ],
        shopPersonPhone: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        shopLimitAmount: [
          { required: true, message: '请输入限额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^(?:[1-9]\d*|0)$/.test(value) == false) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        shopLimitNotify: [{ required: true, validator: checkNum, trigger: 'blur' }],
        shopUser: [{ message: '请选择用户', required: true, trigger: 'blur' }],
        notifyType: [{ message: '请选择通知方式', required: true, trigger: 'change' }],
      },
      onLoadFlage: true, //onload执行开关
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        align: 'left',
        height: 'auto',
        calcHeight: 55,
        tip: false,
        searchShow: true,
        searchMenuSpan: 18,
        border: true,
        index: true,
        indexLabel: '#',
        viewBtn: true,
        dialogClickModal: false,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotName',
            search: false,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '车场名称',
            prop: 'parkingLotId',
            hide: true,
            span: 12,
            search: true,
            showColumn: false,
            searchslot: true,
            searchSpan: 6,
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '商家名称',
            prop: 'shopName',
            rules: [
              {
                required: true,
                message: '请输入商家名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '责任人',
            prop: 'shopResponsiblePerson',
            rules: [
              {
                required: true,
                message: '请输入商家责任人',
                trigger: 'change',
              },
            ],
          },
          {
            label: '手机号码',
            prop: 'shopPersonPhone',
            rules: [
              {
                required: true,
                message: '请输入责任人手机号码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠券类型',
            prop: 'couponNum',
            slot: true,
          },
          {
            label: '商家余额',
            align: 'right',
            prop: 'shopBalance',
            slot: true,
            formslot: true,
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(null, false),
        viewBtn: this.vaildData(this.permission.carcouponshop_view, false),
        delBtn: this.vaildData(null, false),
        editBtn: this.vaildData(null, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$refs.crud.$refs.table.doLayout();
    });
  },
  created() {
    this.initData();
  },
  watch: {
    'addForm.parkingLotId': function (val, oldVal) {
      if (val) {
        userList({ spaceId: val }).then(({ data }) => {
          this.addForm.shopUser = '';
          this.shopUseList = data;
        });
      }
    },
  },
  methods: {
    parkingLotIdChange(value) {
      this.query.parkingLotId = value;
    },
    //打开商家充值明细列表
    openShopRechargeDetail(row) {
      this.shopId = row.id;
      this.shopRechargeDetailVisible = true;
    },
    //打开商家充值页面
    openShopRechargeDialog(form, done) {
      getShopRechargeView({ id: form.id }).then(({ data }) => {
        this.shopRechargeForm = data;
      });

      getDictionary('shop_recharge_discount_number').then((res) => {
        this.discountTypeList = res.data;
      });
      this.shopRechargeDialogFlag = true;
    },
    //商家实缴金额
    rechargeAmountInputChange() {
      this.shopRechargeForm.discountAmount = 0.0;
      console.log('>>>>>>>>>>>>>', this.shopRechargeForm.rechargeAmount);
      if (this.shopRechargeForm.rechargeAmount <= 0) {
        console.log('>>>>>>>>>>>>>', this.shopRechargeForm.rechargeAmount);
        this.shopRechargeForm.discountType = '';
        this.rechargeAmountFlag = true;
      } else {
        this.rechargeAmountFlag = false;
      }
      this.shopRechargeForm.payAmount = this.shopRechargeForm.rechargeAmount;
    },
    //计算商家应缴金额
    changeDiscountType() {
      let shopRecharge = this.shopRechargeForm;
      shopAmountCalculate(shopRecharge).then(
        ({ data }) => {
          this.shopRechargeForm.discountAmount = data.discountAmount;
          this.shopRechargeForm.payAmount = data.payAmount;
        },
        (error) => {
          window.console.log(error);
        }
      );
    },
    //商家充值信息保存
    shopRechargeSubmit(row, done) {
      shopRechargeSave(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.quitShopRechargeDialog();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    //根据优惠折扣计算支付金额
    //退出时清空页面数据
    quitShopRechargeDialog() {
      this.shopRechargeForm.rechargeAmount = '';
      this.shopRechargeDialogFlag = false;
      this.$refs.shopRechargeFormRef.resetForm();
    },
    async initData() {
      await getSpaceTree().then((data) => {
        this.parkingLotList = data.data;
        if (this.parkingLotList.length > 0) {
          this.query.parkingLotId = this.parkingLotList[0].id;
        }
      });
      this.onLoadFlage = false;
      this.onLoad();
    },
    openSendCouponsDialog(row) {
      this.$refs.sendCoupons.openDialog({ parkingLotId: this.query.parkingLotId, shopId: row.id });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },

    rowDel(row) {
      if (row.balance > 0) {
        this.$message.warning('账户余额未结清，不能删除！');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else if ('add' === type) {
        this.cleanForm();
      }
      done();
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = null;
      }
    },
    searchReset() {
      if (this.parkingLotList.length > 0) {
        this.query.parkingLotId = this.parkingLotList[0].id;
      }
      this.onLoad();
    },
    search() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    searchChange(params, done) {
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.onLoadFlage) {
        return;
      }
      this.loading = false;
      if (this.query.parkingLotId == '') {
        return;
      }
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query))
        .then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //新增
    couponShopDialogOpen() {
      this.couponShopAddShow = true;
      //设置默认车场
      if (this.query.parkingLotId) {
        this.addForm.parkingLotId = this.query.parkingLotId;
      } else if (this.parkingLotList.length > 0) {
        this.addForm.parkingLotId = this.parkingLotList[0].id;
      }
      //获取提醒方式类型
      getDictionary('coupon_limit_notify_method').then((data) => {
        if (data.data.length > 0) {
          this.shopNotifyMethodList = data.data;
          // this.addForm.shopNotifyMethod = this.shopNotifyMethodList[0].dictKey;
        }
      });
    },
    couponShopDialogClose() {
      this.$refs['addForm'].resetFields();
      this.couponShopAddShow = false;
      (this.addForm.parkingLotId = ''),
        (this.addForm.shopName = ''),
        (this.addForm.shopResponsiblePerson = ''),
        (this.addForm.shopPersonPhone = ''),
        (this.addForm.shopLimitAmount = ''),
        (this.addForm.shopLimitNotify = ''),
        (this.addForm.shopNotifyMethod = ''),
        (this.addForm.notifyType = ''),
        (this.addForm.shopUser = '');
      this.addForm.lowerBalance = '';
      (this.addForm.subtractType = ''), this.onLoad();
    },
    couponShopAddSubmit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.addForm.shopUser = this.addForm.shopUser.join(',');
          this.addForm.notifyType = this.addForm.notifyType;
          console.log('submit!!');
          add(this.addForm).then(
            () => {
              this.couponShopDialogClose();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              window.console.log(error);
              // loading();
            }
          );
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //编辑
    couponShopEditDialogOpen(row) {
      this.couponShopEditShow = true;

      //设置默认车场
      this.editForm = row;
      this.editForm.shopUser = this.editForm.shopUser.split(',');
      //获取用户列表
      userList({ spaceId: this.editForm.parkingLotId }).then(({ data }) => {
        this.shopUseList = data;
      });
      //获取提醒方式类型
      getDictionary('coupon_limit_notify_method').then((data) => {
        if (data.data.length > 0) {
          this.shopNotifyMethodList = data.data;
          // this.editForm.shopNotifyMethod = this.shopNotifyMethodList[0].dictKey;
        }
      });
    },
    couponShopEditDialogClose() {
      this.$refs['editForm'].resetFields();
      this.couponShopEditShow = false;
      (this.editForm.parkingLotId = ''),
        (this.editForm.shopName = ''),
        (this.editForm.shopResponsiblePerson = ''),
        (this.editForm.shopPersonPhone = ''),
        (this.editForm.shopLimitAmount = ''),
        (this.editForm.shopLimitNotify = ''),
        (this.editForm.shopNotifyMethod = ''),
        (this.editForm.notifyType = ''),
        (this.editForm.shopUser = '');
      this.editForm.lowerBalance = '';
      this.onLoad();
    },
    // 编辑
    couponShopEditSubmit() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.editForm.shopUser = this.editForm.shopUser.join(',');
          this.editForm.notifyType = this.editForm.notifyType;
          this.editForm.shopBalance = '';
          console.log('editsubmit!!');
          update(this.editForm).then(
            () => {
              this.onLoad();
              this.couponShopEditDialogClose();
              this.$message.success('操作成功!');
            },
            (error) => {
              window.console.log(error);
              loading();
            }
          );
        } else {
          console.log('error editsubmit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
#carcouponshop20220323 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search.el-form-item--small.el-form-item {
    width: 100%;
  }
  .avue-crud__search .el-form-item--mini.el-form-item,
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
